
import { useNavigate } from "react-router-dom";
import React, { useState , useEffect } from "react"
import ExecutiveHeader from "./ExecutiveHeader";
import ExecutiveSidebar from "./ExecutiveSidebar"
import Executivehistory from "./Executivehistory";
const ExecutiveDashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [view, setView] = useState("Executivehistory"); // Default view
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
  
    // Load user data from localStorage on mount
    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (storedUser) {
        setUser(storedUser);
      } else {
        // If no user is found, redirect to login
        navigate("/");
      }
    }, [navigate]);
  

console.log("useruseruseruser",user);


    const handleLogout = () => {
      localStorage.removeItem("user");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("role");
      navigate("/"); // Use navigate instead of window.location.href
    };
  
    if (!user) {
      return <div>Loading...</div>; // Show loading state while user data is fetched
    }
  
    return (
      <div className="flex h-screen">
        {/* Sidebar */}
        <ExecutiveSidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          setView={setView}
          handleLogout={handleLogout}
          user={user.executiveName} // Use executiveName from login response
        />
  
        {/* Main Content */}
        <div className="flex-1 flex flex-col">
          <ExecutiveHeader user={user.executiveName} />
  
          {/* Render views based on the selected option */}
          <main className="flex-grow p-6 bg-gray-100">
            {view === "Executivehistory" && <Executivehistory executiveId={user.id} />}
            {/* {view === "Agents-CCE" && <Agentscce user={user} />} */}
            {/* Uncomment and add other views as needed */}
            {/* {view === "Dashboard" && <Dashrigmo setView={setView} user={user} />} */}
            {/* {view === "CallHistory" && <Callhistory user={user} />} */}
            {/* {view === "DoNotDisturb" && <DoNotDisturb user={user} />} */}
            {/* {view === "WaitingList" && <WaitingList user={user} />} */}
          </main>
        </div>
      </div>
    );
  };
  
  export default ExecutiveDashboard;